const hrefOpenNewTab = {
	methods: {
		applyExternalLinkPolicy() {
			const links = this.$el.querySelectorAll('a[href]');
			links.forEach((link) => {
				const href = link.getAttribute('href');
				const isExternal = /^https?:\/\//.test(href);
				if (isExternal) {
					link.setAttribute('target', '_blank');
				}
			});
		},
	},
	mounted() {
		this.applyExternalLinkPolicy();
	},
	updated() {
		this.applyExternalLinkPolicy();
	},
};
